import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IValorCup, IConfCups } from '@/modules/Contratacion/interfaces'
export class CupService extends BaseService<IConfCups> {
  constructor() {
    super({
      baseUrl: 'system/cups/'
    })
  }
  async searchByNameCod (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IConfCups[]>>> {
    return this.http.get<IResponseApi<IConfCups[]>>('/search-by-nom-cod', {
      params
    })
  }
  async deleteHeader(
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<number>>> {
    return this.http.delete<IResponseApi<number>>(`/delete-header`, { params })
  }
  async getHeader(
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.get<IResponseApi<string>>(`/get-header`, { params })
  }
  async getGenerales(): Promise<AxiosResponse<IResponseApi<IConfCups>>> {
    return this.http.get<IResponseApi<IConfCups>>(`/general`)
  }
  async getCupsValor(
    cocsId: number,
    copago: number
  ): Promise<AxiosResponse<IResponseApi<IValorCup[]>>> {
    return this.http.get<IResponseApi<IValorCup[]>>(
      `/get-value-cups/${cocsId}/${copago}`
    )
  }
}
